document.querySelectorAll(".js[data-section-type-copy='founders-slider']").forEach(section => {
    section.classList.remove("js");

    const swiper = section.querySelector(".swiper");
    const swiperPagination = section.querySelector(".swiper-pagination");
    const swiperButtonNext = section.querySelector(".swiper-button-next");
    const swiperButtonPrev = section.querySelector(".swiper-button-prev");

    const slider = new Swiper(swiper, {
        slidesPerView: 1.15,
        grabCursor: true,
        centeredSlides: true,
        spaceBetween: 12,
        pagination: {
            el: swiperPagination,
            clickable: true,
        },
        navigation: {
            nextEl: swiperButtonNext,
            prevEl: swiperButtonPrev,
        },
        breakpoints: {
            750: {
                centeredSlides: false,
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1024: {
                centeredSlides: false,
                slidesPerView: 3,
                spaceBetween: 32,
            },
        },
    });

    if (window.innerWidth <= 750) {
        slider.slideTo(1);
    }

    // Перевірка видимості кнопок навігації
    if (slider.slides.length <= slider.params.slidesPerView) {
        swiperButtonNext.style.display = "none";
        swiperButtonPrev.style.display = "none";
    } else {
        swiperButtonNext.style.display = "flex";
        swiperButtonPrev.style.display = "flex";
    }
});

